import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

const Card = (props) => {
	return (
		<section className={cx('Card', 'card', 'mb-3', props.sectionClass)} id={props.sectionId}>
			<h6 className={cx('card-header', props.headerClass)}>{props.header}</h6>
			{props.children &&
				<div className={cx('card-body', props.bodyClass, {'d-none': props.hideBodyToggle})}>
					{props.children}
				</div>
			}
		</section>
	);
};

Card.propTypes = {
	sectionId: PropTypes.string,
	sectionClass: PropTypes.string,
	bodyClass: PropTypes.string,
	header: PropTypes.any,
	headerClass:PropTypes.string,
	hideBodyToggle: PropTypes.bool,
	children: PropTypes.any
};


export default Card;
